import { Language } from './types';

const BASE_LANGUAGE = {
  tutorialBtnNext: 'Next',
  tutorialBtnEnd: 'Complete',
  tutorialGreeting: 'Hello',
  tutorialSkip: 'Skip tutorial',
  tutorialWelcomeMessage:
    ', we invite you to follow this quick tutorial to start using the platform:',
  tutorialWelcomeMessageUS:
    ', we invite you to follow this quick tutorial to start using your account.',
  tutorialBegin: 'Start',
  tutorialStep1Header: `Let's start!`,
  tutorialStep1Description: `The first step is to add your funds. These can be in the currency of your country.`,
  tutorialStep1Description2: `You can also send your account information to receive third party payments.`,
  tutorialStep2Header: `Make your global transactions with real time exchange rates!`,
  tutorialStep2Description: `EFEX supports 3 payment methods: from your balance, deferred payments, and forwards.`,
  tutorialStep3Header: `Remember that...`,
  tutorialStep3Description: `You will not be able to use the product until you send the documents requested to complete the registration of your account. If you have already done so, you are ready to start sending payments.`,
  tutorialStep4Header: `Create payment link`,
  tutorialStep4Description: `Request your transfers by creating payment links for your customers.`,
  tutorialStep5Header: `Stay connected with all your contacts.`,
  tutorialStep5Description: `You will be able to keep all your customers, employees, vendors, and suppliers connected.`,
  tutorialStepConvertHeader: 'Extraordinary exchange rates',
  tutorialStepConvertDescription:
    'Make conversions between your currency wallets with an extraordinary exchange rate.',
  tutorialStepBalanceDescription:
    'Your USD account balance is custodied and protected by Community Federal Savings Bank, FDIC member with insurance up to USD 250,000 from the US Federal Reserve.',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE;

const ONBOARDING_LANGUAGE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string | object>
> = {
  EN: BASE_LANGUAGE,
  ES: {
    tutorialBtnNext: 'Siguiente',
    tutorialBtnEnd: 'Terminar',
    tutorialGreeting: 'Hola',
    tutorialSkip: 'Omitir tutorial',
    tutorialWelcomeMessage:
      ', te invitamos a seguir esta rápida inducción para que empieces a usar la plataforma:',
    tutorialWelcomeMessageUS:
      ', te invitamos a seguir este rápido tutorial para empezar a utilizar tu cuenta.',
    tutorialBegin: 'Empezar',
    tutorialStep1Header: '¡Empecemos!',
    tutorialStep1Description:
      'El primer paso es añadir tus fondos. Estos pueden ser en la moneda de tu país.',
    tutorialStep1Description2:
      'También puede enviar la información de su cuenta para recibir pagos de terceros.',
    tutorialStep2Header:
      '¡Haz tus transacciones globales con los tipos de cambio en tiempo real!',
    tutorialStep2Description:
      'EFEX admite 3 métodos de pago: : desde tu saldo, pagos diferidos y contratos a futuro.',
    tutorialStep3Header: 'Recuerda que...',
    tutorialStep3Description:
      'No podrás visualizar tus funciones hasta que envíes los documentos solicitados para completar el registro de tu cuenta. Si ya los has enviado, estás listo para empezar a enviar pagos.',
    tutorialStep4Header: 'Crear payment link',
    tutorialStep4Description:
      'Solicita tus transferencias creando links de cobro para tus clientes.',
    tutorialStep5Header: 'Mantente conectado con todos tus contactos',
    tutorialStep5Description:
      'Podrás mantener conectados a todos tus clientes, empleados, vendedores y proveedores.',
    tutorialStepConvertHeader: 'Las mejores tasas',
    tutorialStepConvertDescription:
      'Realiza conversión entre tus monedas con las mejores tasas del mercado.',
    tutorialStepBalanceDescription:
      'El balance de tu cuenta en USD está custodiado y protegido por Community Federal Savings Bank, miembro FDIC con seguro hasta de USD 250,000 por parte de la Reserva Federal the EEUU.',
  },
};

export default ONBOARDING_LANGUAGE_LABELS;
